import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=060f6ff9&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"
import style0 from "./QuestionForm.vue?vue&type=style&index=0&id=060f6ff9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f6ff9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060f6ff9')) {
      api.createRecord('060f6ff9', component.options)
    } else {
      api.reload('060f6ff9', component.options)
    }
    module.hot.accept("./QuestionForm.vue?vue&type=template&id=060f6ff9&scoped=true", function () {
      api.rerender('060f6ff9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/preview/components/QuestionForm.vue"
export default component.exports